"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessServiceErrorToJSON = exports.BusinessServiceErrorFromJSONTyped = exports.BusinessServiceErrorFromJSON = void 0;
const runtime_1 = require("../runtime");
function BusinessServiceErrorFromJSON(json) {
    return BusinessServiceErrorFromJSONTyped(json, false);
}
exports.BusinessServiceErrorFromJSON = BusinessServiceErrorFromJSON;
function BusinessServiceErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'code': !runtime_1.exists(json, 'code') ? undefined : json['code'],
        'property': !runtime_1.exists(json, 'property') ? undefined : json['property'],
        'message': !runtime_1.exists(json, 'message') ? undefined : json['message'],
    };
}
exports.BusinessServiceErrorFromJSONTyped = BusinessServiceErrorFromJSONTyped;
function BusinessServiceErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'code': value.code,
        'property': value.property,
        'message': value.message,
    };
}
exports.BusinessServiceErrorToJSON = BusinessServiceErrorToJSON;
//# sourceMappingURL=BusinessServiceError.js.map